function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import classNames from 'classnames';
import Icon from '../../Icon';
import { useCustomField } from '../../../common/hooks/useCustomField';
import './index.scss';

const NumberField = ({
  className,
  isInvalid,
  isValid,
  step,
  min,
  max,
  diverge,
  allowEmpty,
  value,
  name,
  onChange,
  wholeNumber,
  splittedAction,
  ...props
}) => {
  const allowHandleBlur = useRef(false);
  const actionPressed = useRef(false);
  const [customField, setCustomField] = useCustomField({
    name: name,
    value: value,
    onChange
  });

  const createHandleAction = action => {
    if (props.disabled) {
      return;
    }

    return () => {
      actionPressed.current = true;
      let cleanup = 0;
      let updateStamp = window.performance.now();
      const timestampStart = window.performance.now();

      const animation = () => {
        if (actionPressed.current) {
          cleanup = window.requestAnimationFrame(timelapsed => {
            if (timelapsed - timestampStart > 500
            /*greater than 500miliseconds*/
            ) {
              if (timelapsed - updateStamp > 100
              /*greater than 100miliseconds*/
              ) {
                updateStamp = window.performance.now();
                setCustomField(prev => {
                  let newValue = parseFloat(action === 'plus' ? prev.value + step : prev.value - step);

                  if (diverge) {
                    newValue = Math.round(newValue / step) * step;
                  }

                  newValue = parseFloat(newValue.toFixed(2));
                  const clamp = action === 'plus' ? max : min;
                  return { ...prev,
                    dirty: true,
                    value: Math[action === 'plus' ? 'min' : 'max'](typeof clamp !== 'undefined' ? clamp : newValue, newValue)
                  };
                });
              }
            }

            animation();
          });
        } else {
          window.cancelAnimationFrame(cleanup);
        }
      };

      animation();
      setCustomField(prev => {
        let newValue = action === 'plus' ? parseFloat(prev.value || min || "0") + (prev.value === '' ? 0 : step) : parseFloat(prev.value || "0") - step;

        if (diverge) {
          newValue = Math.round(newValue / step) * step;
        }

        newValue = parseFloat(newValue.toFixed(2));
        const clamp = action === 'plus' ? max : min;
        return { ...prev,
          dirty: true,
          value: Math[action === 'plus' ? 'min' : 'max'](typeof clamp !== 'undefined' ? clamp : newValue, newValue)
        };
      });
    };
  };

  const handlePlus = createHandleAction('plus');
  const handleMinus = createHandleAction('minus');

  const handleChange = event => {
    allowHandleBlur.current = true;
    const value = event.target.value === '' ? '' : parseFloat(event.target.value);
    setCustomField(prev => ({ ...prev,
      dirty: true,
      value: value
    }));
  };

  const handleBlur = event => {
    if (allowHandleBlur.current) {
      allowHandleBlur.current = false;

      if (event.target.value === '') {
        const newValue = typeof min !== 'undefined' && !allowEmpty ? min : '';
        setCustomField(prev => ({ ...prev,
          dirty: true,
          value: newValue
        }));
      } else {
        let newValue = parseFloat(event.target.value) || 0;

        if (diverge) {
          newValue = Math.round(newValue / step) * step;
        }

        newValue = parseFloat(newValue.toFixed(2));
        setCustomField(prev => ({ ...prev,
          dirty: true,
          value: Math.max(typeof min !== 'undefined' ? min : newValue, Math.min(max || newValue, newValue))
        }));
      }
    }
  };

  const handleRemovePress = () => {
    actionPressed.current = false;
  };

  return splittedAction ? /*#__PURE__*/React.createElement("div", {
    className: classNames("form-number-split-action", {
      'is-invalid': isInvalid,
      'is-valid': isValid
    })
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "form-number-action",
    onMouseDown: handleMinus,
    onMouseUp: handleRemovePress,
    onMouseLeave: handleRemovePress
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "minus"
  })), /*#__PURE__*/React.createElement("input", _extends({}, props, {
    type: "number",
    value: customField.value,
    className: className,
    onChange: handleChange,
    onBlur: handleBlur,
    onKeyDown: e => {
      if (diverge && (e.keyCode === 13 || e.key === 'Enter')) {
        e.preventDefault();
      }
    }
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "form-number-action",
    onMouseDown: handlePlus,
    onMouseUp: handleRemovePress,
    onMouseLeave: handleRemovePress
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classNames('form-number', {
      'is-invalid': isInvalid,
      'is-valid': isValid
    })
  }, /*#__PURE__*/React.createElement("input", _extends({}, props, {
    type: "number",
    value: customField.value,
    className: className,
    onChange: handleChange,
    onBlur: handleBlur,
    onKeyDown: e => {
      if (diverge && (e.keyCode === 13 || e.key === 'Enter')) {
        e.preventDefault();
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-number-spinner"
  }, /*#__PURE__*/React.createElement("span", {
    className: "form-number-spinner-add",
    onMouseDown: handlePlus,
    onMouseUp: handleRemovePress,
    onMouseLeave: handleRemovePress
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  })), /*#__PURE__*/React.createElement("span", {
    className: "form-number-spinner-minus",
    onMouseDown: handleMinus,
    onMouseUp: handleRemovePress,
    onMouseLeave: handleRemovePress
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "minus"
  }))));
};

NumberField.defaultProps = {
  name: "",
  step: 1
};
export default NumberField;